export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20romantic%20abstract%20background%20with%20flowing%20gradients%20of%20warm%20coral%20and%20rose%20gold%20tones%20gentle%20waves%20and%20light%20particles%20dreamy%20atmosphere%20elegant%20minimalist%20style&width=1600&height=800&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 to-background-950/40"></div>

      <div className="relative z-10 container-page text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-5">
          准备好开始你的<strong>爱情之旅</strong>了吗？
        </h2>
        <p className="text-white/70 max-w-lg mx-auto mb-10 leading-relaxed">
          立即注册爱情岛网站，开启属于你的浪漫邂逅。数百万用户已在这里找到真爱，下一个就是你。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-300 cursor-pointer"
          >
            免费注册账号
          </a>
          <a
            href="#"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-medium border-2 border-white/30 text-white hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            下载官方App
          </a>
        </div>
      </div>
    </section>
  );
}